import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "rearrange",
  "use": "rearrange-usage",
  "viewBox": "0 0 8 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 14\" id=\"rearrange\"><path d=\"M1.5 3.5C2.3 3.5 3 2.8 3 2S2.3.5 1.5.5 0 1.2 0 2s.7 1.5 1.5 1.5m0 7c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5S3 12.8 3 12s-.7-1.5-1.5-1.5m0-5C.7 5.5 0 6.2 0 7s.7 1.5 1.5 1.5S3 7.8 3 7s-.7-1.5-1.5-1.5M6.5 3.5C7.3 3.5 8 2.8 8 2S7.3.5 6.5.5 5 1.2 5 2s.7 1.5 1.5 1.5m0 7c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5S8 12.8 8 12s-.7-1.5-1.5-1.5m0-5C5.7 5.5 5 6.2 5 7s.7 1.5 1.5 1.5S8 7.8 8 7s-.7-1.5-1.5-1.5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol